import { Pipe } from '@angular/core';

@Pipe({
  name: 'summarize'
})
export class SummarizePipe {
  transform(value) {
    if (value && value.length > 150) {
      return `${value.slice(0,150)}…`;
    } else {
      return value;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/summarize.pipe.ts